import { InternalAxiosRequestConfig } from 'axios';
import { appSession } from '@/shared/lib';

export function addAuthHeader(config: InternalAxiosRequestConfig<unknown>) {
  const session = appSession.getItem();

  if (session?.access_token) {
    config.headers.Authorization = 'Bearer ' + session.access_token;
  }

  return config;
}
